<div class="row justify-content-between panel m-3">
    <div class="col-md-5">
        <h4>Shipping Address</h4>
        <p>{{shippingAddress.fullName}}</p>
        <p *ngIf="shippingAddress.suite?.length > 0">Suite {{shippingAddress.suite}}</p>
        <p>{{shippingAddress.addressLine1}}</p>
        <p *ngIf="shippingAddress.addressLine2?.length > 0">{{shippingAddress.addressLine2}}</p>
        <p>{{shippingAddress.city}}</p>
        <p>{{shippingAddress.regionAbbrOrName}}</p>
        <p>{{shippingAddress.countryName}}</p>
        <p>{{shippingAddress.postalCode}}</p>
        <p *ngIf="shippingAddress.buzzerNumber?.length > 0">Buzzer Number: {{shippingAddress.buzzerNumber}}</p>
        <p>Phone Number: {{shippingAddress.phoneNumber}}</p>
    </div>
    <div class="col-md-5">
        <h4>Billing Address</h4>
        <p>{{billingAddress.fullName}}</p>
        <p *ngIf="billingAddress.suite?.length > 0">Suite {{billingAddress.suite}}</p>
        <p>{{billingAddress.addressLine1}}</p>
        <p *ngIf="billingAddress.addressLine2?.length > 0">{{billingAddress.addressLine2}}</p>
        <p>{{billingAddress.city}}</p>
        <p>{{billingAddress.regionAbbrOrName}}</p>
        <p>{{billingAddress.countryName}}</p>
        <p>{{billingAddress.postalCode}}</p>
        <p *ngIf="billingAddress.buzzerNumber?.length > 0">Buzzer Number: {{billingAddress.buzzerNumber}}</p>
        <p>Phone Number: {{billingAddress.phoneNumber}}</p>
    </div>
    <div class="col-md-2">
        <p><a [routerLink]="['/checkout/address']">Change</a></p>
    </div>
</div>
